import { PriceFormatted as CheerzApiPrice } from "@Types/api/price";
import { PriceFormatted } from "@Types/price";

export const convertFromPriceContentToApi = (contentPrice: PriceFormatted): CheerzApiPrice => {
  return {
    cents: contentPrice.cents,
    currency: contentPrice.currency,
    formatted_price: contentPrice.formattedPrice,
  };
};

export const convertFromApiToPrice = (jsonPrice: CheerzApiPrice): PriceFormatted => {
  return {
    cents: jsonPrice.cents,
    currency: jsonPrice.currency,
    formattedPrice: jsonPrice.formatted_price,
  };
};
